import React from 'react';
import { Box, Text, List, ListItem, ListItemText } from '@razorpay/blade/components';

export type InstructionsViewProps = {
  instructions: Array<string>;
};

export const InstructionsView = ({ instructions }: InstructionsViewProps) => {
  return (
    <Box marginBottom='spacing.8'>
      <Text weight='semibold'>💡 Instruction to fill</Text>
      <List variant='ordered' marginTop='spacing.4'>
        {instructions.map((item, index) => (
          <ListItem key={index}>
            <ListItemText weight='regular' color='surface.text.gray.subtle'>{item}</ListItemText>
          </ListItem>
        ))}
      </List> 
    </Box>
  );
};

